<template>
  <div class="page1">
    <div style="
      margin: auto;
      width: 1200px;
      height: 109px;
          z-index: 1000">
      <div style="color: #FFFFFF; font-size: 30px;font-family: 微软雅黑; font-weight: bold ;padding-top:35px">{{
          this.systemName
        }}
      </div>
    </div>
    <div style="width:100%;background-color: #004e96; height: 65px">
      <div
        style=" font-weight: bold;width: 1200px;margin: auto"
      >
        <navigation-bar :default-active="'动态'"/>
      </div>
    </div>

    <div style="width: 1200px;margin: auto;">
    <el-row style="padding-top: 15px;margin-left: 20px;height: 20px">
      <el-col >
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item v-if="aim1">工作动态</el-breadcrumb-item>
          <el-breadcrumb-item v-if="defaultSelect==='2'||defaultSelect==='21' || defaultSelect==='22' || defaultSelect==='23'">标准动态</el-breadcrumb-item>
          <el-breadcrumb-item v-if="defaultSelect==='3'">政策法规</el-breadcrumb-item>
          <el-breadcrumb-item v-if="defaultSelect==='4'">行业动态</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col style="width: 150px">
        <el-menu :default-active=index  mode="vertical" active-text-color="#FFFFFF" style="height: 224px;border-right: none">
          <el-menu-item @click.native="initial" style="font-size: 16px;font-family: SourceHanSansCN-Regular;text-align: center;" index="1" @click="select('1')">工作动态</el-menu-item>
          <el-menu-item @click.native="start" style="font-size: 16px;font-family: SourceHanSansCN-Regular;text-align: center;" :index="aaa.toString()"  @click="select('2')">标准动态</el-menu-item>
          <el-menu-item @click.native="start" style="font-size: 16px;font-family: SourceHanSansCN-Regular;text-align: center;" index="3" @click="select('3')">政策法规</el-menu-item>
          <el-menu-item @click.native="start" style="font-size: 16px;font-family: SourceHanSansCN-Regular;text-align: center;" index="4" @click="select('4')">行业动态</el-menu-item>
        </el-menu>
      </el-col>
      <!--工作动态-->

      <el-col v-if="aim"  style="margin-left: 10px;width: 1030px;min-height: 500px">
        <el-tabs ref="navTabs"  type="border-card" v-model="activeName1">
          <el-tab-pane label="公示公告" name="first">
            <announce  :name="'detail'" v-on:listenAnnounce="listenAnnounce"/>
          </el-tab-pane>
          <el-tab-pane label="项目征集" name="second">
            <project-collect  :name="'detail'" v-on:listenProject="listenProject"/>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <!--标准动态-->
      <el-col v-if="defaultSelect==='2'&&this.id===null" style="margin-left: 10px;width: 1030px;min-height: 500px; background-color: #FFFFFF;">
        <div style="margin:20px 0px 20px 10px;width: 780px">
<!--          <el-col  style="margin-left: 20px;margin-top:20px;width: 780px">-->
          <el-input style="width: 25%" v-model="a100" placeholder="请输入标准号" clearable></el-input>
          <el-input style="width: 30%" v-model="a298" placeholder="请输入标准中文名" clearable></el-input>
<!--          <el-input style="width: 30%" v-model="countTime" placeholder="请输入发布时间" clearable></el-input>-->
          <el-date-picker
            v-model="countTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            class="filter-item"
            clearable
            style="width: 30%"
          />
          <el-button style="height: 40px" type="primary" size="medium" @click="searchTimeList" icon="el-icon-search">查询</el-button>
<!--          </el-col>-->
        </div>
        <el-tabs ref="navTabs" type="border-card" @tab-click="change" v-model="activeName2">
          <el-tab-pane label="最新发布" name="first">
            <standard-newest v-if="activeName2 == 'first'" @click.native="start" :showActiveName="showActiveName" :a100= "a100" :a298= "a298" :countTime="countTime" :name="'detail'" v-on:listenNews="listenNews"/>
            </el-tab-pane>
<!--          <el-tab-pane label="即将实施" name="second">
            <standard-implementation v-if="activeName2 == 'second'" :showActiveName="showActiveName" @click.native="start" :a100= "a100" :a298= "a298" :countTime= "countTime" :name="'detail'" v-on:listenNews="listenNews"/>
            </el-tab-pane>
          <el-tab-pane label="即将作废" name="third">
            <standard-nullify @click.native="start" v-if="activeName2 == 'third'" :showActiveName="showActiveName" :a100= "a100" :a298= "a298" :countTime= "countTime" :name="'detail'" v-on:listenNews="listenNews"/>
          </el-tab-pane>-->
        </el-tabs>
      </el-col>
      <!--政策法规-->
      <el-col v-if="defaultSelect==='3'&&this.id===null" style="margin-left: 10px;width: 1030px;min-height: 500px">
        <el-tabs type="border-card" v-model="activeName3">
          <el-tab-pane label="相关政策" name="first">
            <policy @click.native="start" :name="'detail'" v-on:listenPolicy="listenPolicy"/>
            </el-tab-pane>
        </el-tabs>
      </el-col>
      <!--行业动态-->
      <el-col v-if="defaultSelect==='4'&&this.id===null" style="margin-left: 10px;width: 1030px;min-height: 500px">
        <el-tabs type="border-card" v-model="activeName4">
          <el-tab-pane label="行业资讯" name="first">
            <news @click.native="start" :name="'detail'" v-on:listenNews="listenNews"/>
            </el-tab-pane>
        </el-tabs>
      </el-col>

      <!--详细信息展示-->
      <!--行业资讯-->
      <el-col v-if="defaultSelect==='4'&&this.id!=null" style="margin-left: 10px;width: 1030px;min-height: 500px;background-color: #FFFFFF">
        <news-detail :id="id" style="margin-top:20px "/>
      </el-col>
      <!--相关政策-->
      <el-col v-if="defaultSelect==='3'&&this.id!=null" style="margin-left: 10px;width: 1030px;min-height: 500px;background-color: #FFFFFF">
        <policy-detail :id="id" style="margin-top:20px "/>
      </el-col>
      <!--公示公告-->
      <el-col v-if="defaultSelect==='11'&&this.id!=null" style="margin-left: 10px;width: 1030px;min-height: 500px;background-color: #FFFFFF">
        <announce-detail :id="id" style="margin-top:20px "/>
      </el-col>
      <!--项目征集-->
      <el-col v-if="defaultSelect==='12'&&this.id!=null" style="margin-left: 10px;width: 1030px;min-height: 500px;background-color: #FFFFFF">
        <project-collect-detail :id="id" style="margin-top:20px "/>
      </el-col>
      <!--最新发布-->
      <el-col v-if="defaultSelect==='21'&&this.id!=null" style="margin-left: 10px;width: 1030px;min-height: 500px;background-color: #FFFFFF">
        <standard-detail :id="id" style="margin-top:20px "/>
      </el-col>
      <!--即将实施-->
      <el-col v-if="defaultSelect==='22'&&this.id!=null" style="margin-left: 10px;width: 1030px;min-height: 500px;background-color: #FFFFFF">
        <standard-detail :id="id" style="margin-top:20px "/>
      </el-col>
      <!--即将作废-->
      <el-col v-if="defaultSelect==='23'&&this.id!=null" style="margin-left: 10px;width: 1030px;min-height: 500px;background-color: #FFFFFF">
        <standard-detail :id="id" style="margin-top:20px "/>
      </el-col>

    </el-row>
  </div>
  </div>
</template>
<script>
import ProjectCollect from "./compoment/projectCollect";
import Announce from "./compoment/announce";
import Policy from "./compoment/policy";
import News from "./compoment/news";
import request from "../../utils/request";
import NewsDetail from "./compoment/newsDetail";
import PolicyDetail from "./compoment/policyDetail";
import AnnounceDetail from "./compoment/announceDetail";
import ProjectCollectDetail from "./compoment/projectCollectDetail";
import StandardNewest from "./compoment/standardNewest";
import StandardImplementation from "./compoment/standardImplementation";
import StandardNullify from "./compoment/standardNullify";
import StandardDetail from "./compoment/standardDetail";
import {getSystemName} from "../../utils/systemInfo";
import NavigationBar from "./compoment/navigationBar";
export default {
  name:'detail',
  components: {
    NavigationBar,
    StandardDetail,
    StandardNullify,
    StandardImplementation,
    StandardNewest,
    ProjectCollectDetail, AnnounceDetail, PolicyDetail, NewsDetail, ProjectCollect, Announce, Policy, News},
  data(){
    return{
      aaa:[0,],
      aim:true,
      aim1:true,
      input: "",
      imageUrlTop:require('../../../static/image/home.jpg'),
      activeName1:'first',
      activeName2:'first',
      activeName3:'first',
      activeName4:'first',
      defaultSelect:'1',
      id:'0',
      systemName:getSystemName(),
      index:'1',
      a100: '',
      a298: '',
      countTime: '',
      showActiveName: true
    }
  },
  methods:{
    change() {
      this.a100 = ''
      this.a298 = ''
      this.countTime = ''
    },
    searchTimeList() {
      this.showActiveName = !this.showActiveName
    },
    initial(){
      this.aim1=true
      this.aim=true
    },
    start(){
      this.aim1=false;
      this.aim=false
    },
    start1(){
     this.aim1=true;
     this.aim=false
    },
    listena(val){
      this.defaultSelect=val.index
      this.id=val.id
    },
     listenb(val){
      this.defaultSelect=val.index
      this.id=val.id
    },
     listenc(val){
      this.defaultSelect=val.index
      this.id=val.id
    },
    listenNews(val){
      this.defaultSelect=val.index
      this.id=val.id
    },
    listenPolicy(val){
      this.defaultSelect=val.index
      this.id=val.id
    },
    listenAnnounce(val){
      this.defaultSelect=val.index
      this.id=val.id
      this.aim=false
    },
    listenProject(val){
      this.defaultSelect=val.index
      this.id=val.id
      this.aim=false
    },
    /**
     * 选中侧边栏触发
     */
    select(index){
      this.id=null
      this.defaultSelect=index
    },
    /**
     * 首页跳转
     */
    homeClick(){
      this.$router.push({path:'/home'})
    },
    /**
     * 标准体系跳转
     */
    standardClick(){
      this.$router.push({path:'/standardSystem'})
    },
    /**
     * 跳转标准查询页
     */
    toSearch() {
      this.$router.push({ path: "/standard", query: { input: this.input } });
    },

  },
  updated() {

  },
  mounted(){
    document.title = this.systemName;
  },
  created(){
    this.defaultSelect=this.$route.query.index;
    this.id=this.$route.query.id;
    if (this.defaultSelect == 1 && this.$route.query.name) {
      this.activeName1 = this.$route.query.name
    }
    if(this.defaultSelect==2 && this.$route.query.name) {
      this.activeName2 = this.$route.query.name;
    }
    if(this.defaultSelect==11){
      this.aim1=true;
      this.aim=false
    }else if(this.defaultSelect==12){
      this.aim1=true
      this.aim=false
    }
    else if(this.defaultSelect>1){
      this.aim1=false
      this.aim=false
      this.index=this.$route.query.index
      if(this.index=="2"){
        this.aaa="2"
      }else if(this.index=="21"){
        this.aaa="21"
      }else if(this.index=="22"){
        this.aaa="22"
      }else if(this.index=="23"){
        this.aaa="23"
      }
    }
  }
}
</script>
<style>
.el-menu-item.is-active{
  background: #004e96;
}
.el-menu.el-menu--horizontal{
  border-bottom:0
}
</style>
<style scoped>
.page1{
  background: url("../../../static/image/body-bg.jpg") no-repeat;
  height: 100%;
  width: 100%;
  background-size:100% 775px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/detail.vue